export default "__VITE_ASSET__w6WeZxPg__"